import React, { useState, useEffect } from "react";
import _ from "lodash";

import { MdFilterList } from "react-icons/md";
import { FaWindowClose } from "react-icons/fa";
import { getLabel } from "../../tools/Dictionary";


import "./ListFilter.css";

const ListFilter = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const OnApplyFilter = props.OnApplyFilter;

  //State
  const [column, setColumn] = useState([]);
  const [display, setDisplay] = useState(false);
  const [filtered, setFiltered] = useState(false);


  //Afficha de la fenêtre
  const toggleDisplay = () => {
    setColumn(_.cloneDeep(props.column.filter(c => !c.isImage)));
    setDisplay(display => !display);
  };


  //Changement de l'opérateur du filtre
  const onChangeOperator = (e) => {
    const index = e.currentTarget.dataset.index;

    let newColumn = [...column];

    newColumn[index].filterOperator = e.target.value;

    setColumn(newColumn);
  };

  //Changement de la valeur du filtre
  const onChangeValue = (e) => {
    const index = e.currentTarget.dataset.index;

    let newColumn = [...column];

    newColumn[index].filterValue = e.target.value;

    setColumn(newColumn);
  };

  //Lance onClickAuth si Enter est appuyé
  const onPressKey = (e) => {
    if (e.key === "Enter"){
      OnApplyFilter(column);
      toggleDisplay();
    }
  }

  //Appliquer les filtres
  const onApplyFilter = () => {

    let isFiltered = false;

    if (column.findIndex(col => !(col.filterOperator === "like" && col.filterValue === "")) > -1)
      isFiltered = true;

    setFiltered(isFiltered);

    OnApplyFilter(column);
    toggleDisplay();
  };


  //Vider les filtres
  const onResetFilter = () =>
  {
    const newColumn = [...column.map(col =>
    {
      return {
        ...col,
        filterOperator: "like",
        filterValue: ""
      }
    })];

    setColumn(newColumn);
    OnApplyFilter(newColumn);
    setFiltered(false);
    toggleDisplay();
  };


  useEffect(() => {
    setFiltered(props.column.findIndex(col => !col.noFilter && !(col.filterOperator === "like" && col.filterValue === "")) > -1);
  }, [props.column]);

  const displayOperator = (col, index) => {

    if (col.format == "boolean")
      return (
        <div className="listfilter_body_col" style={{width: "40%"}}>
          <select value={col.filterOperator} data-index={index} className="page_select_input " onChange={onChangeOperator}>
            <option value="like">{getLabel("ListFilter", "like")}</option>
          </select>
        </div>
      );

    return (
      <div className="listfilter_body_col" style={{width: "40%"}}>
        <select value={col.filterOperator} data-index={index} className="page_select_input " style={{width: "100%"}} onChange={onChangeOperator}>
          <option value="like">{getLabel("ListFilter", "like")}</option>
          <option value="notlike">{getLabel("ListFilter", "notlike")}</option>
          <option value="=">{getLabel("ListFilter", "equal")}</option>
          <option value="!=">{getLabel("ListFilter", "different")}</option>
          <option value=">">{getLabel("ListFilter", "greater than")}</option>
          <option value="<">{getLabel("ListFilter", "lesser than")}</option>
        </select>
      </div>
    );

  };

  const displayValue = (col, index) => {

    if (col.format == "boolean")
      return (
        <div className="listfilter_body_col" style={{width: "60%"}}>
          <select value={col.filterValue} data-index={index} className="page_select_input " onChange={onChangeValue}>
            <option value="" />
            <option value={true} >{col.booleanValue[true]}</option>
            <option value={false} >{col.booleanValue[false]}</option>
          </select>
        </div>
      );

    return (
      <div className="listfilter_body_col" style={{width: "60%"}}>
        <input
          data-index={index}
          className="page_text_input"
          onChange={onChangeValue}
          onKeyUp={onPressKey}
          type="text"
          value={col.filterValue || ""}
          style={{height: "30px"}}
        />
      </div>
    );
  }

  return (
    <div>
      <div className={IsDesktop ? "listfilter_cont" : "listfilter_mobile_cont"} title={getLabel("ListFilter", "Filters")} onClick={toggleDisplay}>
        {IsDesktop &&
        <div className="listfilter_text">
            {getLabel("ListFilter", "Filters")}
        </div>
        }
        <div className={IsDesktop ? "listfilter_icon" : "actionbutton_mobile_icon"} style={{ color: (filtered ? "black": "white")}}>
          <MdFilterList />
        </div>
      </div>
      {display &&
        <div className="listfilter_modal">
          <div className="listfilter_modal_cont">
            <div className="listfilter_header">
              <div className="listfilter_header_row" style={{ width: "20px" }} />
              <div className="listfilter_header_row" style={{ lineHeight: "50px" }}>
                {getLabel("ListFilter", "Filters")}
              </div>
              <div className="listfilter_header_row" style={{ width: "20px", textAlign: "right" }}>
                <div className="listfilter_close" title={getLabel("ListFilter", "Close")} onClick={toggleDisplay}>
                  <FaWindowClose />
                </div>
              </div>
            </div>
            <div className="listfilter_body">
              {column.filter(c => !c.noFilter).map((col, index) => (
                <div key={index} className="listfilter_body_property_row">
                  <div className="listfilter_body_col" >
                    <div className="listfilter_body_property">
                      {col.label}
                    </div>
                  </div>
                  {displayOperator(col, index)}
                  {displayValue(col, index)}
                </div>
              ))}
            </div>
            <div className="listfilter_footer">
              <div className="page_button listfilter_button" style={{ backgroundColor: "grey" }} onClick={onResetFilter}>{getLabel("ListFilter", "Clear")}</div>
              <div className="page_button listfilter_button" style={{ backgroundColor: "" }} onClick={onApplyFilter}>{getLabel("ListFilter", "Apply")}</div>
            </div>
          </div>
        </div>
      }
    </div>
  )

};

export default ListFilter;
